/**
 * ShareHandler class to handle social media share functionality.
 *
 * This class attaches click event listeners to social media share buttons
 * and opens a new window for sharing, adjusting window size based on the platform.
 */
export const ShareHandler = function() {
    !function() {
        jQuery('body').on('click', '.share', open_window);
    }();

    /**
     * Opens a new window for social media sharing.
     *
     * @param {Event} event The click event.
     * @return {boolean} False to prevent default action, true for email links.
     */
    function open_window(event) {
        // If email, allow default action
        if (jQuery(this).hasClass('email')) return true;

        event.preventDefault();

        let myHeight = '';

        if (jQuery(this).hasClass('facebook')) {
            myHeight = '800';
        } else if (jQuery(this).hasClass('twitter')) {
            myHeight = '275';
        } else if (jQuery(this).hasClass('linkedin')) {
            myHeight = '500';
        } else if (jQuery(this).hasClass('instagram')) {
            myHeight = '500';

            const src = jQuery(this).attr("href");
            const imgTitle = jQuery(this).data('title');

            // Call Image utility
            downloadBase64File(src, imgTitle);

            return false;
        }

        const url = jQuery(this).attr('href');
        const myWidth = '600';
        const left = (screen.width - myWidth) / 2;
        const top = (screen.height - myHeight) / 4;
        const newwindow = window.open(url, 'Share', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${myWidth}, height=${myHeight}, top=${top}, left=${left}`);

        if (window.focus) {
            newwindow.focus();
        }
        return false;
    }
};